<nav ngxNavbarDynamicExpand style="position:fixed; top: 0px; width: 100%; z-index: 900; background-color: black;  ">
    <button class="navbar-toggler" type="button" (click)="collapse.toggle();  " aria-controls="main-nav"
        aria-expanded="false" aria-label="Toggle navigation" style="background-color: white; ">

        <span class="
            navbar-toggler-icon
          ">
            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 20 10">
                <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="2" transform="translate(1 1)">
                    <path d="M0 6h18M0 0h18M0 12h18" />
                </g>
            </svg>
        </span>
    </button>

    <div>
        <img src="assets/images/logo/logo-ampi.png" class="" alt="" height="80px">
    </div>
    <ngx-navbar-collapse #collapse="ngxNavbarCollapse">


        <ul
            class="navbar-nav w-100 d-flex align-items-start align-items-md-center justify-content-md-end justify-content-end">
            <!-- <li class="nav-item active">
          <a class="nav-link" href="#" style="color:white"><img
              src="https://ampi.org/wp-content/uploads/2023/02/LOGO-CIRCULAR-PLATEADO-2022-150x150.png" class=""
              alt="" height="80px"></a>
        </li> -->
            <li class="nav-item mr-3">
                <a class="nav-link" style="color:white; font-weight: bold;  font-size: 15px;"
                    (click)="selectedOptionMenu(1)">PROPIEDADES</a>
            </li>
            <li class="nav-item mr-3">
                <a class="nav-link" style="color:white; font-weight: bold;  font-size: 15px;"
                    (click)="selectedOptionMenu(2)">NOSOTROS</a>
            </li>
            <li class="nav-item mr-3">
                <a class="nav-link" style="color:white; font-weight: bold;  font-size: 15px;"
                    (click)="selectedOptionMenu(3)">ASOCIADOS</a>
            </li>

            <li class="nav-item mr-3">
                <a class="nav-link" style="color:white; font-weight: bold;  font-size: 15px;"
                    (click)="selectedOptionMenu(4)">BENEFICIOS</a>
            </li>

            <li class="nav-item mr-3 ">
                <a class="nav-link" style="color:white; font-weight: bold;  font-size: 15px;"
                    (click)="selectedOptionMenu(5)">EVENTOS</a>
            </li>

            <li class="nav-item mr-3 d-md-none d-block">
                <a class="nav-link" style="color:white; font-weight: bold;  font-size: 15px;"
                    (click)="redirectSN(5)">LOGIN</a>
            </li>

            <li class="nav-item iconsSNStyle">

                <a (click)="redirectSN(1)" title="Facebook" class="a13_soc-facebook fa fa-facebook-square mr-1 mr-md-3"
                    rel="noopener" style="color:white; font-size: 30px;  margin-top: 5px;" *ngIf="linkFace"></a>
                <a (click)="redirectSN(2)" title="Instagram" class="a13_soc-instagram fa fa-instagram mr-1 mr-md-3"
                    rel="noopener" style="color:white; font-size: 30px;" *ngIf="linkInsta"></a>
                <a (click)="redirectSN(3)" title="YouTube" class="a13_soc-youtube fa fa-youtube-play mr-1 mr-md-3"
                    rel="noopener" style="color:white;  font-size: 30px; " *ngIf="linkYou">
                </a>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
                    class="bi bi-tiktok icons mr-2  pointerCursor" viewBox="1 1 20 20"
                    style="color: white; margin-bottom: 8px;" (click)="redirectSN(4)" *ngIf="linkTik">
                    <path
                        d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z" />
                </svg>

                <a (click)="redirectSN(5)" title="Acceder" class="a13_soc-youtube fa fa-user d-md-inline d-none mr-3"
                    rel="noopener" style="color:white;  font-size: 30px; ">
                </a>



            </li>
        </ul>
    </ngx-navbar-collapse>
</nav>

<div style="height: 90px;"></div>